<script setup lang="ts">
import { SwiperSlide } from 'swiper/vue';

import type { IWarehouseMagazineItemDataClientDTO } from '~/shared/api/client/warehouse-magazine/warehouse-magazine.dto';
import { useSwiperControlsVisibility } from '~/shared/lib/useSwiperControlsVisibility';
import { DEFAULT_PUBLISHER_STYLE_PROPS_WAREHOUSE } from '~/shared/lib/publishers.const';
import type { TPublisherStyleProps } from '~/shared/lib/publishers.types';
import SliderItem from '~/shared/ui/slider/SliderItem.vue';
import { getAuthorName } from '~/shared/lib/getAuthorName';

const { $viewport } = useNuxtApp();

const props = withDefaults(
  defineProps<
    {
      items: IWarehouseMagazineItemDataClientDTO[];
    } & TPublisherStyleProps
  >(),
  DEFAULT_PUBLISHER_STYLE_PROPS_WAREHOUSE,
);

const itemsCount = computed(() => props.items.length);
const isControlVisible = useSwiperControlsVisibility(
  itemsCount,
  $viewport.breakpoint,
);

const DATA = computed(() => ({
  title: 'CRE',
  subTitle: 'Журнал',
  titleLink: '/journal',
  titleLinkExternal: true,
  arrowColor:
    props.textColor || DEFAULT_PUBLISHER_STYLE_PROPS_WAREHOUSE.textColor,
  borderColor:
    props.borderColor || DEFAULT_PUBLISHER_STYLE_PROPS_WAREHOUSE.borderColor,
  backgroundColor:
    props.backgroundColor ||
    DEFAULT_PUBLISHER_STYLE_PROPS_WAREHOUSE.backgroundColor,
  textColor:
    props.textColor || DEFAULT_PUBLISHER_STYLE_PROPS_WAREHOUSE.textColor,
  breakpoints: true,
  isControlVisible: isControlVisible.value,
}));
</script>

<template>
  <Slider v-if="items.length > 0" v-bind="DATA">
    <SwiperSlide
      v-for="(item, key) in items"
      :key="`sliderWarehouse_${key}`"
      :style="{ borderColor: DATA.borderColor }"
      :class="$style.swiperSlide"
    >
      <SliderItem
        v-bind="item"
        :id="item.news.id"
        :text-color="DATA.textColor"
        :title="item.title"
        :subject="item.subject"
        :image="
          item?.image_one?.file_url ||
          (item.news && item.news.image?.file_url) ||
          null
        "
        :author="getAuthorName(item.news.author)"
        :type="item.news.type"
        :redirect="item.news.redirect"
      />
    </SwiperSlide>
  </Slider>
</template>

<style module lang="scss">
.swiperSlide {
  width: 270px;
  height: auto;
  border-right: 1px solid;
}

@media (max-width: 767px) {
  .swiperSlide {
    border-right: none;
    width: 100%;
  }
}
</style>
